import { Avatar, Box, CardContent, Grid, Typography } from "@mui/material";
import { Card } from "react-bootstrap";
import './StatCard.css';

function StatCard({ title, value, icon, color }) {
    return (
      <Grid item xs={12} sm={6} md={3}>
        <Card className="stats-card">
          <CardContent>
            <Box className="stats-content">
              <Avatar style={{ backgroundColor: `${color}20`, color: color }} className="stats-icon">
                {icon}
              </Avatar>
              <Typography variant="h5" className="stats-value">
                {value}
              </Typography>
            </Box>
            <Typography variant="subtitle1" className="stats-title">
              {title}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    );
}
export default StatCard;